import React, { useState, useRef, useEffect } from 'react';
import './CustomSelect.css';

const CustomSelect = ({ 
  options = [], 
  value = '', 
  onChange = () => {}, 
  placeholder = 'Выберите...', 
  modif = 'base',
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const selectRef = useRef(null);
  const optionsRef = useRef(null);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (optionValue, optionText) => {
    setSelectedValue(optionValue);
    onChange(optionValue);
    setIsOpen(false);
  };

  const selectedOption = options.find(option => option.value === selectedValue);
  const displayText = selectedOption ? selectedOption.text : placeholder;

  return (
    <div 
      ref={selectRef}
      className={`select select--${modif} ${isOpen ? '--select-open' : ''} ${selectedValue ? '--select-active' : ''} ${className}`}
    >
      <button
        type="button"
        className="select__title"
        onClick={handleToggle}
      >
        <span className="select__value">
          <span className="select__content">
            {displayText}
          </span>
        </span>
      </button>
      <div className="select__body">
        <div 
          ref={optionsRef}
          className={`select__options ${isOpen ? '--slide' : ''}`}
          style={{ display: isOpen ? 'block' : 'none' }}
        >
          <div className="select__scroll">
            {options.map((option, index) => (
              option.isLink ? (
                <a
                  key={index}
                  href={option.href}
                  className={`select__option base-link ${selectedValue === option.value ? '--select-selected' : ''}`}
                  data-fls-select-value={option.value}
                >
                  {option.text}
                </a>
              ) : (
                <button
                  key={index}
                  type="button"
                  className={`select__option ${selectedValue === option.value ? '--select-selected' : ''}`}
                  onClick={() => handleOptionClick(option.value, option.text)}
                  data-fls-select-value={option.value}
                >
                  {option.text}
                </button>
              )
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomSelect;